import {InjectionToken} from "@angular/core";
import {ModelKey} from "../models/ModelKey";
import {IController} from "./IController";
import {ModalFlagModel} from "../models/ModalFlagModel";
import {ModalHeaderConfigModel} from "../models/ModalHeaderConfigModel";
import {ModalFooterConfigModel} from "../models/ModalFooterConfigModel";

export const IT_MODAL_CONTROLLER = new InjectionToken<IModalController>('IT_MODAL_CONTROLLER');
export const MK_MODAL_HEADER_CONFIG = new ModelKey<ModalHeaderConfigModel>('MK_MODAL_HEADER_CONFIG');
export const MK_MODAL_FOOTER_CONFIG = new ModelKey<ModalFooterConfigModel>('MK_MODAL_FOOTER_CONFIG');
export const MK_MODAL_FLAG = new ModelKey<ModalFlagModel>('MK_MODAL_FLAG');

export interface IModalController extends IController {

  handleInit(eventData: any): any;
}
